import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {QuestionService} from '../../services/question.service';
import {Questions} from '../../domain/questions';
import {AddQuestionDialogComponent} from './add-question-dialog/add-question-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {NotificationService} from '../../services/notification.service';

@Component({
  selector: 'tech-core-quiz-question-config',
  standalone: false,
  templateUrl: './question-config.component.html',
  styleUrl: './question-config.component.scss'
})
export class QuestionConfigComponent implements OnInit {

  public displayedColumns = ['questionId', 'question', 'correct_answer', 'actions'];
  public dataSource = new MatTableDataSource();


  constructor(
    private questionService: QuestionService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
  ) {
  }


  ngOnInit(): void {
    this.loadQuestions()
  }

  loadQuestions() {
    this.questionService.getQuestions().subscribe({
      next: data => {
        this.dataSource.data = data
      }
    })
  }

  deleteQuestion(question: Questions) {
    this.questionService.deleteQuestion(question).subscribe({
      next: value => {
        this.loadQuestions()
      }
    })
  }

  editQuestion(question: Questions) {
    this.openAddDialog(question)
  }

  createQuestion() {
    this.openAddDialog(null)
  }

  openAddDialog(question: Questions | null) {
    const dialogRef = this.dialog.open(AddQuestionDialogComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      width: '800px',
      height: '800px',
      autoFocus: false,
      data: {
        question: question
      }
    });
    dialogRef.afterClosed().subscribe((response) => {
      this.loadQuestions();
      switch (response.status) {
        case 200:
          this.notificationService.success("Question was added");
          break;
        case 409:
          this.notificationService.failure("Failure adding question");
          break;
        case "closed":
          break;
        default:
          this.notificationService.failure('Error');
      }
    });
  }
}
